import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { IRootState } from '../../store/reducer';
import { IMatchupsResponse, ITeam, Leagues } from '../pick6/store/types';
import { getLeague } from '../pick6/optimizerHelper';
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Menu, MenuItem, useTheme } from '@mui/material';
import { addMatchupFilter, removeMatchupFilter, setMatchups } from './store/slice';
import { getMatchupsByLeague } from './store/actions';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { APIConstants } from '../utils/api/constants';

const MatchupsWithCheckboxComponent = () => {
  const { league, matchupsByLeague: matchups, additionalParlayLegFilters } = useSelector((state: IRootState) => state.pickemOptimizer);
  const filters = additionalParlayLegFilters.events ?? [];
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const getDisplayLabel = (matchup: IMatchupsResponse) => {
    const homeTeam = matchup?.participants?.find((p) => p.isHome)?.team || ({} as ITeam);
    const awayTeam = matchup?.participants?.find((p) => !p.isHome)?.team || ({} as ITeam);
    let displayLabel = <div />;
    let isCollege =
      [Leagues.NCAAF, Leagues.NCAAB].indexOf(
        getLeague(matchup?.leagueInstance?.leagueCode),
      ) > -1;

    displayLabel = (
      <Box className="row">
        <Box className="team">
          <Box className="img-wrapper">
            <img src={awayTeam?.logo} alt='' />
          </Box>
          <Box
            component="div"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            {(isCollege ? awayTeam.school : awayTeam.title)}
          </Box>
        </Box>
        <span>@</span>
        <Box className="team">
          <Box className="img-wrapper">
            <img src={homeTeam?.logo} alt='' />
          </Box>
          <Box
            component="div"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            {(isCollege ? homeTeam.school : homeTeam.title)}
          </Box>
        </Box>
      </Box>
    );


    return displayLabel;
  };

  const handleChange = (event: any, option: IMatchupsResponse) => {
    const toAdd = event.target.checked;
    if (toAdd) {
      dispatch(addMatchupFilter(option));
    } else if (!toAdd) {
      dispatch(removeMatchupFilter(option));
    }
  };

  React.useEffect(() => {
    const getMatchups = async () => {
      if (league !== Leagues.ALL) {
        if (league === Leagues.NFL) {
          const matchups = await getMatchupsByLeague(league.toString(), dayjs().toISOString(), dayjs().add(10, 'day').toISOString());
          dispatch(setMatchups(matchups));
        } else {
          const matchups = await getMatchupsByLeague(league.toString());
          dispatch(setMatchups(matchups));
        }
      }
    }
  getMatchups();
  }, [league])
  
  console.log('league', league);
  return (
    <Grid
      sx={{
        root: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
          },
        }
      }}
      item>
      <Box
        sx={{
          root: {
            width: '100%',
          }
        }}
        data-filter="matchups">
        <Button
          sx={{
            height: 40,
            minWidth: 125,
            width: '100%',
            maxWidth: '100% !important',
            [theme.breakpoints.down('sm')]: {
              width: '100%',
            },
            justifyContent: 'space-between !important',
            textTransform: 'capitalize !important',
            padding: '4px 12px !important',
            border: `1px solid ${theme.palette.grey[300]}`,
            color: theme.palette.common.white,
            fontWeight: 500,
            fontSize: 13,
            '&.MuiButton-outlinedPrimary': {
              color: theme.palette.common.white
            },
            '& .MuiSvgIcon-root': {
              color: theme.palette.common.white,
            },
            '&.selected': {
              backgroundColor: theme.palette.grey[700],
              color: theme.palette.getContrastText(theme.palette.grey[700]),
              fontWeight: 500,
            },
            '&.disabled': {
              backgroundColor: theme.palette.grey[100],
              color: theme.palette.getContrastText(theme.palette.grey[100]),
              fontWeight: 500,
            },
          }}
          aria-controls="button-menu"
          aria-haspopup="true"
          variant="outlined"
          color="primary"
          onClick={handleClick}
          disabled={league === Leagues.ALL}
          endIcon={<ArrowDropDownIcon color="secondary" />}
          style={{
            backgroundColor: '#1C1C1C',
            border: '0px'
          }}
        >
          Matchups
        </Button>
        <Menu
          sx={{
            '& .MuiPaper-root': {
              border: '1px solid #d3d4d5',
              '& .row': {
                display: 'flex',
                justifyContent: 'flex-start',
                flexDirection: 'row',
                alignItems: 'center',
                '& .team': {
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  minWidth: 150,
                  width: 150,
                  whiteSpace: 'nowrap',
                  [theme.breakpoints.down('sm')]: {
                    width: '100%',
                    whiteSpace: 'inherit',
                  },
                  '& .img-wrapper': {
                    width: '20px',
                    height: '20px',
                    marginRight: '4px',
                    '& img': {
                      height: '100%',
                      width: '100%',
                      objectFit: 'contain',
                    },
                  },
                  '& p': {
                    fontWeight: 500,
                  },
                },
                '& span': {
                  marginRight: '4px',
                  marginLeft: '8px',
                },
              },
            },
          }}
          elevation={0}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            elevation: 1,
            style: {
              maxHeight: 100 * 4.5,
              width: '55ch',
            },
          }}
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {matchups?.data?.length === 0
            && <MenuItem
              disabled={true}>
              No Matchups Found
            </MenuItem>}
          {matchups?.status === APIConstants.SUCCEEDED
            && matchups?.data?.length > 0
            && matchups?.data.map((option: IMatchupsResponse) => (
              <MenuItem key={option.id}>
                <FormControl
                  key={option.id} id={option.id}>
                  <FormGroup>
                    <FormControlLabel
                      key={option.id}
                      id={option.id}
                      value="start"
                      control={
                        <Checkbox
                          checked={
                            !!filters?.find((fd) => fd === option.id)
                          }
                          size="small"
                          color="secondary"
                          onChange={(e) => handleChange(e, option)}
                        />
                      }
                      label={getDisplayLabel(option)}
                      labelPlacement="start"
                    />
                  </FormGroup>
                </FormControl>
              </MenuItem>
            ))}
        </Menu>
      </Box>
    </Grid>
  )
}

export default MatchupsWithCheckboxComponent